import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UserUtils from '../lib/UserUtils'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Group from './sidebar/Group'
import Icon from './Icon'

@connect(state => ({roles: state.roles}))
export default class extends Component {
  static contextTypes = {
    site: PropTypes.object.isRequired
  }

  render () {
    const {site} = this.context
    const {roles} = this.props
    const canCreate = UserUtils.can(site, 'create', 'user_role')

    return <nav>
      <Group
        group={{id: null, name: 'User Roles'}}
        items={roles}
        path={`/${site.id}/users`}
      />
      {canCreate &&
        <div className='sidebar-action'>
          <Link to={`/${site.id}/users/new`}><Icon name='plus' /> User Role</Link>
        </div>
      }
    </nav>
  }
}



// WEBPACK FOOTER //
// ./app/components/SidebarUsers.js